import { apiClient } from './apiClient';
import type { ResolvedRelationshipPayload } from './relationships';

export type FilingStatus = {
  id: number;
  name: string;
};

export type FilingStatusResponse = {
  results: FilingStatus[];
  totalCount: number;
};

export type ValidateFilingStatusesPayload = {
  dateEstablished?: string;
  closeDate?: string;
  filingStatuses: {
    id: number;
    startingDate: string;
    endingDate?: string;
    description: string;
  }[];
  relationships?: ResolvedRelationshipPayload[];
};

export const getFilingStatuses = (params?: {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortType?: string;
}): Promise<FilingStatusResponse> => {
  return apiClient.get(`/filing-statuses`, { ...params });
};

export const validateFilingStatusesHistory = (
  clientId: number,
  payload: ValidateFilingStatusesPayload
): Promise<{ isValid: boolean; validationErrors?: string[] }> => {
  return apiClient.post(
    `clients/${clientId}/validate-filing-statuses-history`,
    payload
  );
};
